import {SET_BLOGS_LIST_QUERY} from '../const'

export const blog = (state = {},action) =>{
    switch (action.type) {
        case SET_BLOGS_LIST_QUERY:
            const newState2 = {...state}
            newState2.blogs = action.value.blogs
            newState2.query = action.value.query || ''
            newState2.page = action.value.page ||0
            newState2.Nitems = action.value.Nitems
            if (action.value.author) {
                newState2.author = action.value.author
            }

            return newState2;
        default:
            return state;
    }
}